import { Briefcase, Calendar, Lock, MapPin, Search, Send, UserRound } from "lucide-react";

const formatDate = (value) => value ? new Intl.DateTimeFormat("en-IN", { dateStyle: "medium" }).format(new Date(value)) : "Not recorded";

export default function CandidateSearchCard({ candidate, onRequestAccess }) {
  const masked = candidate.visibility === "masked";
  const application = candidate.latest_application || {};
  return (
    <article className="rounded-lg border border-teal/30 bg-navy-light p-5 shadow-lg">
      <div className="mb-3 flex items-start justify-between gap-3">
        <div>
          <h3 className="font-heading text-lg font-semibold text-textLight">
            {masked ? candidate.candidate_reference : candidate.name}
          </h3>
          {masked && <p className="mt-1 flex items-center gap-1 text-xs text-gold"><Lock size={13} /> Protected profile</p>}
        </div>
        <span className="rounded border border-teal/30 bg-teal/10 px-2 py-1 text-xs text-teal">{candidate.status}</span>
      </div>
      <div className="space-y-2 text-sm text-textLight/80">
        <p className="flex gap-2"><Briefcase size={16} className="shrink-0 text-gold" />{candidate.role}</p>
        <p className="flex gap-2"><MapPin size={16} className="shrink-0 text-gold" />{candidate.location}</p>
        <p className="flex gap-2"><UserRound size={16} className="shrink-0 text-teal" />{candidate.experience_months == null ? "Experience not recorded" : `${Math.floor(candidate.experience_months / 12)}y ${candidate.experience_months % 12}m`}</p>
        <p className="text-xs">Sector: <span className="text-teal">{candidate.sector}</span></p>
        {candidate.domain_tags?.length > 0 && <p className="text-xs">Domains: {candidate.domain_tags.join(", ")}</p>}
        <p className="text-xs">Skills: {candidate.skills}</p>
        {!masked && <p className="text-xs">{candidate.email || "No email"}{candidate.phone ? ` · ${candidate.phone}` : ""}</p>}
      </div>
      <div className="mt-4 border-t border-teal/20 pt-3 text-xs text-textLight/70">
        <p className="flex items-center gap-1"><Calendar size={13} /> Added to SPES: {formatDate(candidate.added_to_spes_at)}</p>
        <p className="mt-1">Application: {formatDate(application.applied_on)}{application.source_system ? ` · ${application.source_system}` : ""}{application.source_channel ? ` (${application.source_channel})` : ""}</p>
      </div>
      {masked && <button type="button" onClick={() => onRequestAccess(candidate)} className="mt-4 flex w-full items-center justify-center gap-2 rounded bg-teal px-3 py-2 text-sm font-medium text-white hover:bg-teal-dark"><Send size={15} /> Request access for JD</button>}
      {!masked && candidate.call_log_count > 0 && <p className="mt-3 text-xs text-gold">{candidate.call_log_count} call log{candidate.call_log_count === 1 ? "" : "s"}</p>}
    </article>
  );
}
